// src/components/common/MicButton.jsx
import { IconButton, Tooltip, InputAdornment } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";

const MicButton = ({ isListening, onStart, onStop }) => (
  <InputAdornment position="end" sx={{ alignSelf: "flex-start", mt: "6px" }}>
    <Tooltip title={isListening ? "Stop recording" : "Voice to text"}>
      <IconButton
        size="small"
        onClick={isListening ? onStop : onStart}
        sx={{
          color: isListening ? "error.main" : "action.active",
          "@keyframes micPulse": {
            "0%": { opacity: 1 },
            "50%": { opacity: 0.35 },
            "100%": { opacity: 1 },
          },
          animation: isListening
            ? "micPulse 1.4s ease-in-out infinite"
            : "none",
          "&:hover": {
            color: isListening ? "error.dark" : "neutral.teal",
          },
        }}
      >
        <MicIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </InputAdornment>
);

export default MicButton;
